import React from "react";
import { Helmet } from "react-helmet";
import * as styles from "./styles.module.css";
import { saveConsent } from "../../actions/consent";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";
import ConsentMessage from "../consent_message";
import ConsentForm from "../consent_form";
import ConsentError from "../consent_error";
import PageContextError from "../token_missing";
import PropTypes from "prop-types";
import ConsentDeclineModal from "../consent_decline";
import jwt from "jsonwebtoken";

import { SAVE_CONSENT_SUCCESS } from "../../shared/constants/action-types";

import {
  CONSENT_ACCEPT,
  CONSENT_DECLINE,
} from "../../shared/constants/consent";
import { PUA_CONSENT, SSO_CONSENT } from "./consents";

class Consent extends React.Component {
  constructor(props) {
    super(props);
    const jwtToken = this.tokenDetails(props);

    console.log("Setting state");
    this.state = {
      consent: "",
      error: false,
      tokenMissing: jwtToken === null,
      jwtToken: jwtToken,
      token: new URLSearchParams(props.location.search).get("token"),
      gdprPrompt: this.getPrompt(jwtToken?.authType || "SSO"),
      isModalOpen: false,
    };

    this.onSubmit = this.onSubmit.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.onConsentAccept = this.onConsentAccept.bind(this);
    this.onModalSubmit = this.onModalSubmit.bind(this);
    this.onModalCancel = this.onModalCancel.bind(this);
    this.onConsentDecline = this.onConsentDecline.bind(this);
  }

  getPrompt(authType) {
    if (authType === "SSO") {
      return SSO_CONSENT;
    }

    return PUA_CONSENT;
  }

  componentDidUpdate(prevProps) {
    if (this.props.error || this.state.error) {
      return;
    }

    const data = this.props.data;
    if (data && prevProps.data !== data) {
      switch (data.type) {
        case SAVE_CONSENT_SUCCESS:
          this.handleSaveConsent(this.props.accepted);
          return;
        default:
          throw new Error("Unknown action type");
      }
    }
  }

  tokenDetails(props) {
    const token = new URLSearchParams(props.location.search).get("token");

    if (!token) {
      console.warn("No token found in query string");
      return null;
    }

    // get the decoded payload and header
    const decodedToken = jwt.decode(token, { complete: true });
    return decodedToken.payload;
  }

  getStateId(props) {
    return new URLSearchParams(props.location.search).get("state");
  }

  handleError() {
    this.setState({
      error: true,
    });
  }

  handleSaveConsent(accepted) {
    if (typeof window !== "undefined") {
      const auth0Path = this.props.auth0Path;
      window.location.replace(
        accepted
          ? `${auth0Path}/continue?state=${this.getStateId(this.props)}`
          : `/deleted`,
      );
    }
  }

  onModalSubmit() {
    this.props.saveConsent({
      userId: this.state.jwtToken.userId,
      isConsented: false,
      token: this.state.token,
    });
    this.setState({ isModalOpen: false });
  }

  onModalCancel() {
    this.setState({ isModalOpen: false });
  }

  onSubmit() {
    if (this.state.consent === CONSENT_ACCEPT) {
      this.props.saveConsent({
        userId: this.state.jwtToken.userId,
        isConsented: true,
        token: this.state.token,
      });
    }
    if (
      typeof window !== "undefined" &&
      this.state.consent === CONSENT_DECLINE
    ) {
      this.setState({ isModalOpen: true });
    }
  }

  onCancel() {
    if (typeof window !== "undefined") {
      const url = this.props.products[this.state.jwtToken.interfaceId];
      if (url) {
        window.location.replace(url);
      } else {
        console.log(
          "No product configured for" + this.state.jwtToken.interfaceId,
        );
      }
    }
  }

  onConsentAccept() {
    this.setState({
      consent: CONSENT_ACCEPT,
    });
  }

  onConsentDecline() {
    this.setState({
      consent: CONSENT_DECLINE,
    });
  }

  render() {
    console.log(
      `what is error ${this.state.error} and props error ${this.props.error}`,
    );

    if (this.state.tokenMissing) {
      return <PageContextError />;
    }

    const error = this.state.error || this.props.error;
    if (error) {
      return <ConsentError error={error} />;
    }

    const gdprPrompt = this.state.gdprPrompt;
    if (!gdprPrompt) {
      return <React.Fragment />;
    }

    return (
      <React.Fragment>
        <Helmet>
          <title> EBSCO Health | My Account </title>
          <meta
            name="EBSCO Health | My Account"
            content="EBSCO Health | My Account"
          />
          <link rel="icon" type="image/x-icon" href="EBSCOFavicon.ico" />
        </Helmet>

        <ConsentMessage prompt={gdprPrompt.prompt} />

        <ConsentForm
          acceptResponse={gdprPrompt.validResponseObj.response_label_true}
          declineResponse={gdprPrompt.validResponseObj.response_label_false}
          onConsentAccept={this.onConsentAccept}
          onConsentDecline={this.onConsentDecline}
        />

        <div className={styles.formButton}>
          <button
            className={styles.button}
            onClick={this.onSubmit}
            disabled={!this.state.consent}
          >
            Continue
          </button>
          <button className={styles.button} onClick={this.onCancel}>
            Cancel
          </button>
        </div>
        <ConsentDeclineModal
          isModalOpen={this.state.isModalOpen}
          onModalSubmit={this.onModalSubmit}
          onModalCancel={this.onModalCancel}
        />
      </React.Fragment>
    );
  }
}

Consent.displayName = "Consent";

Consent.propTypes = {
  responseStatus: PropTypes.string,
};

Consent.defaultProps = {
  responseStatus: "NOT_RESPONDED",
};

export const mapStateToProps = (state) => {
  const { consentReducer } = state;
  const auth0Path = state.paths.auth0 || "";
  const products = state.paths.products || "";
  const { data, error, accepted } = consentReducer || {};
  return {
    data,
    accepted,
    error,
    auth0Path,
    products,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      saveConsent,
    },
    dispatch,
  );

export { Consent as _unconnected };
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Consent),
);
